export default "__VITE_ASSET__DGiRZy91__"